import { z } from 'zod';
// ---------- Contactos de cliente (estilo HubSpot/Pipedrive) ----------
// Personas de contacto asociadas a un Client (empresa o persona física).
// Un cliente puede tener varios contactos; opcionalmente uno marcado como
// `isPrimary` (interlocutor principal).
export const ClientContactDtoSchema = z.object({
    id: z.string(),
    clientId: z.string(),
    name: z.string(),
    role: z.string().nullable(),
    email: z.string().nullable(),
    phone: z.string().nullable(),
    notes: z.string().nullable(),
    isPrimary: z.boolean(),
    createdAt: z.string().datetime(),
});
export const CreateClientContactSchema = z.object({
    name: z.string().trim().min(2).max(200),
    role: z.string().trim().max(120).nullable().optional(),
    email: z.string().trim().email().max(200).nullable().optional(),
    phone: z.string().trim().max(40).nullable().optional(),
    notes: z.string().max(2000).nullable().optional(),
    isPrimary: z.boolean().default(false),
});
export const UpdateClientContactSchema = z
    .object({
    name: z.string().trim().min(2).max(200).optional(),
    role: z.string().trim().max(120).nullable().optional(),
    email: z.string().trim().email().max(200).nullable().optional(),
    phone: z.string().trim().max(40).nullable().optional(),
    notes: z.string().max(2000).nullable().optional(),
    isPrimary: z.boolean().optional(),
})
    .refine((d) => Object.keys(d).length > 0, { message: 'Sin cambios' });
export const ClientContactListResponseSchema = z.object({
    items: z.array(ClientContactDtoSchema),
});
//# sourceMappingURL=client-contacts.js.map